import { Component, OnInit } from '@angular/core';
import { ModalLetUsHelpYouService } from '../../services/modal-let-us-help-you.service';
import { filter, first, takeUntil } from 'rxjs/operators';
import { NavigationEnd, NavigationStart, Router, NavigationBehaviorOptions } from '@angular/router';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';

@Component({
  selector: 'app-let-us-help-you',
  templateUrl: './let-us-help-you.component.html',
  styleUrls: ['./let-us-help-you.component.scss']
})
export class LetUsHelpYouComponent implements OnInit {

  constructor(
    private modalLetUsHelpYouService: ModalLetUsHelpYouService,
    public router: Router,
  ) { } 

  ngOnInit(): void {
  }


  letUsHelpYouModalOpen(){
    const modalRef = this.modalLetUsHelpYouService.open();
    
    modalRef.onClose.pipe().subscribe(() =>{
      this.modalLetUsHelpYouService.modalRef = null;
    })
  }

}
